import { useGetAllEmployeeGroups, useGetAllPersons, useGetPersonsEmployeeGroupSummary } from '@hr/api/endpoints'
import { LoadingContainer } from '@hr/common/loaders/loadingcontainer'
import { LabelMeter } from '@hr/common/meter/LabelMeter'
import { useTranslation } from 'react-i18next'
import styles from './Card.module.css'

export function GroupGenderDistribution() {
	const { t } = useTranslation()

	const { data: groups } = useGetAllEmployeeGroups() // determine active employee group status
	const { data: groupPersons } = useGetPersonsEmployeeGroupSummary() // detemine which group a person belongs
	const { data: persons } = useGetAllPersons() // determine person employed status

	const countDistribution = () => {
		const groupMap = {}
		let activeGroups = 0
		groups.forEach((group) => {
			if (group.active) {
				++activeGroups
				groupMap[group.id] = group
				group.women = 0
				group.men = 0
			}
		})

		const personGroupMap = {}
		groupPersons.forEach((person) => {
			personGroupMap[person.personId] = person.employeeGroupId
		})

		persons.forEach((person) => {
			const status = person.employmentDetails?.personStatus
			if ((status === 'EMPLOYED' || !status) && person.socSec) {
				const groupId = personGroupMap[person.personId]
				const group = groupMap[groupId]
				if (group) {
					const g = (person.gender || '').trim().toUpperCase()
					if (g === 'M') ++group.men
					else if (g === 'N') ++group.women
				}
			}
		})

		return (
			<>
				<div style={{ display: 'flex', justifyContent: 'space-between' }}>
					<h4 className={styles.cardHeader}>{t('EmployeeGroups', 'Työntekijäryhmät')}</h4>
					<p
						style={{
							border: '1px solid #ccc',
							borderRadius: '5px',
							padding: '.5em',
							marginRight: '.5em',
							marginTop: '-.5em',
						}}
					>
						<span style={{ opacity: 0.8 }}>{t('ActiveGroups', 'Aktiivisia ryhmiä')}</span>
						<b className={styles.bigFigure} style={{ marginRight: 0 }}>
							{activeGroups}
						</b>
					</p>
				</div>

				<table style={{ width: '100%' }}>
					<thead>
						<tr style={{ borderBottom: '1px solid #eee' }}>
							<th>{t('EmployeeGroup', 'Työntekijäryhmä')}</th>
							<th>{t('Total', 'Yhteensä')}</th>
							<th>{t('Women', 'Naiset')}</th>
							<th>{t('Men', 'Miehet')}</th>
							<th>{t('GenderDistribution', 'Sukupuolijakauma')}</th>
						</tr>
					</thead>
					<tbody>
						{Object.values(groupMap).map((group) => (
							<tr key={group.id} style={{ borderBottom: '1px solid #eee' }} className="padded">
								<td>
									<span className={styles.groupBadge} style={{ background: group.colour }} title={group.groupCode}>
										{group.name}
									</span>
								</td>
								<td>{group.women + group.men}</td>
								<td>{group.women}</td>
								<td>{group.men}</td>
								<td>
									<LabelMeter
										leftLabel={
											group.women + group.men > 0 && `${Math.round((group.women / (group.women + group.men)) * 100)} %`
										}
										value={group.women / (group.women + group.men)}
										rightLabel={
											group.women + group.men > 0 && `${Math.round((group.men / (group.women + group.men)) * 100)} %`
										}
									/>
								</td>
							</tr>
						))}
					</tbody>
				</table>

				<div className={styles.legend}>
					<div>
						<span style={{ background: 'var(--palette-1)' }}></span>
						{t('Women', 'Naiset')}
					</div>
					<div>
						<span style={{ background: 'var(--palette-2)' }}></span>
						{t('Men', 'Miehet')}
					</div>
				</div>
			</>
		)
	}

	return groups && groupPersons && persons ? countDistribution() : <LoadingContainer />
}
